import { SxProps, Theme } from '@mui/material'
import { menuItemClasses } from '@mui/material/MenuItem'

// Dropdown Paper of the filter-bar buttons (Sort, Image Size, Items Per Page, ...). The top padding leaves room for
// the button the Popper overlaps (FILTER_BTN_HEIGHT minus its 1px border).
export const filterMenuPaperSx: SxProps<Theme> = {
  paddingTop: '41px',
  [`& .${menuItemClasses.root}`]: {
    fontSize: '14px',
    minHeight: '40px',
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: '#f0f9f7',
    },
    [`&.${menuItemClasses.selected}`]: {
      color: '#005058',
      fontWeight: 500,
      backgroundColor: 'transparent',
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: '#dcece8',
      },
    },
  },
}
